import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'sectionPermissionPipe' })
export class SectionPermissionPipe implements PipeTransform {
  transform(userSectionPermissions: string[], id: number): boolean {
    if (userSectionPermissions && userSectionPermissions.length) {
      return userSectionPermissions.some((sectionId) => sectionId === '' + id);
    } else {
      return false;
    }
  }
}
